var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0256 17.8572L78 50L95.0256 82.1429L102 78.2776V21.7225L95.0256 17.8572Z",
    fill: "#E25444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6 17.8572L59.406 21.7225L42 50L59.406 78.2776L93.6 82.1429V17.8572Z",
    fill: "#7B1D13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7857 17.8572L18 20.2984V79.7017L23.7857 82.1429L60 50L23.7857 17.8572Z",
    fill: "#58150D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2002 17.8572L60.0002 27.4278V73.4751L25.2002 82.1429V17.8572Z",
    fill: "#E25444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0197 32.1429L44.4004 29.6371L60.0197 11.9048L75.6004 29.6371L60.0197 32.1429Z",
    fill: "#58150D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6004 29.6036L60.0004 32.1429L44.4004 29.6036V11.9048",
    fill: "#58150D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0197 67.8572L44.4004 70.5169L60.0197 84.5238L75.6004 70.5169L60.0197 67.8572Z",
    fill: "#58150D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.952 0L44.4004 7.90876V29.7619L60.0004 25.5301L59.952 0Z",
    fill: "#7B1D13"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0004 36.9048L44.4004 38.5226V60.2032L60.0004 61.9048V36.9048Z",
    fill: "#7B1D13"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0004 74.0525L44.4004 70.238V92.0387L60.0004 99.9999V74.0525Z",
    fill: "#7B1D13"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6 70.238L60 74.0536V99.9999L75.6 92.0387V70.238Z",
    fill: "#E25444"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 36.9048L75.6 38.5226V60.2032L60 61.9048V36.9048Z",
    fill: "#E25444"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0L75.6 7.90876V29.7619L60 25.5994V0Z",
    fill: "#E25444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3Logo);
export default __webpack_public_path__ + "static/media/S3-logo.36f177a5a690cb18a760101608d61eee.svg";
export { ForwardRef as ReactComponent };